export enum EResponseExceptionStatus {
    Unknown,
    InventoryClosedError,
}